<template>
  <div>
    <b-card no-body class="mt-3">
      <template v-slot:header>
        <h5 class="mb-0">{{ input.headline }}</h5>
      </template>

      <b-list-group flush>
        <!-- row1 -->
        <b-list-group-item v-if="input.row1.text != ''">
          <b-row align-v="center">
            <b-col class="ml--2">
              <!-- <span class="mb-0">
                Wie lange wird gepflegt (min.)
              </span> -->
              <span class="mb-0"> {{ input.row1.text }}</span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  style="text-align:right;"
                  :disabled="input.row1.disabledCheck"
                  v-model="row1value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon :icon="input.row1.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>

        <!-- row2 -->
        <b-list-group-item v-if="input.row2.text != ''">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> {{ input.row2.text }}</span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="input.row2.disabledCheck"
                  v-model="row2value"
                  onFocus="this.select()"
                  lazy
                />
                <b-input-group-append is-text>
                  <b-icon :icon="input.row2.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>

        <!-- row3 -->
        <b-list-group-item variant="light" v-if="input.row3.text != ''">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0">
                {{ input.row3.text }}
              </span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="input.row3.disabledCheck"
                  v-model="row3value"
                  onFocus="this.select()"
                  lazy
                />
                <b-input-group-append is-text>
                  <b-icon :icon="input.row3.icon" />
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>

        <!-- row4 -->
        <b-list-group-item variant="light" v-if="input.row4.text != ''">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0">
                {{ input.row4.text }}
              </span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="input.row4.disabledCheck"
                  v-model="row4value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon :icon="input.row4.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col
          ></b-row>
        </b-list-group-item>

        <!-- row5 -->
        <b-list-group-item variant="light" v-if="input.row5.text != ''">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> {{ input.row5.text }} </span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="input.row5.disabledCheck"
                  v-model="row5value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon :icon="input.row5.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col
          ></b-row>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "InputCard",
  props: ["input"],
  data() {
    return {
      row1: null
    };
  },
  methods: {
    //Methode die einen Währungsstring in eine normale Number umwandelt (z.B: 1.540,30 € -> 1540.3)
    realParseFloat(s) {
      if (s == "" || s == null) {
        s = "0";
      }
      s = s.replace(/[^\d,.-]/g, ""); // strip everything except numbers, dots, commas and negative sign
      if (
        navigator.language.substring(0, 2) !== "de" &&
        /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(s)
      ) {
        // if not in German locale and matches #,###.######
        s = s.replace(/,/g, ""); // strip out commas
        return parseFloat(s); // convert to number
      } else if (/^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(s)) {
        // either in German locale or not match #,###.###### and now matches #.###,########
        s = s.replace(/\./g, ""); // strip out dots
        s = s.replace(/,/g, "."); // replace comma with dot
        return parseFloat(s);
      } // try #,###.###### anyway
      else {
        s = s.replace(/,/g, ""); // strip out commas
        return parseFloat(s); // convert to number
      }
    },
    rowFormating(rowFormat, stateObj) {
      if (rowFormat == "currency") {
        //formatiert ins local Währungsformat inkl€
        return stateObj.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR"
        });
      } else if (rowFormat == "time") {
        //TODO falls es ander formatierungen geben soll
        return stateObj + " Minuten";
      } else if (!rowFormat) {
        //formatiert in lokale Dezimalschreibweise (. -> ,)
        return stateObj.toLocaleString("de-DE");
      }
    },
    gettersToLocaleCurrency(value) {
      return this.$store.getters[value].toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    }
  },
  computed: {
    row1value: {
      get() {
        var value = this.$store.state[this.input.row1.vuexModule][
          this.input.row1.stateObj
        ][this.input.row1.value];

        return this.rowFormating(this.input.row1.rowFormat, value);
      },
      //TODO If-Abfrage ob string oder number?
      set(value) {
        this.$store.commit(
          this.input.row1.mutationName,
          this.realParseFloat(value)
        );
        this.$store.commit("setIsSaved");
      }
    },
    row2value: {
      get() {
        var value = this.$store.state[this.input.row2.vuexModule][
          this.input.row2.stateObj
        ][this.input.row2.value];

        return this.rowFormating(this.input.row2.rowFormat, value);
      },
      set(value) {
        this.$store.commit(
          this.input.row2.mutationName,
          this.realParseFloat(value)
        );
        this.$store.commit("setIsSaved");
      }
    },
    row3value() {
      if (this.input.row3.rowFormat == "currency") {
        return this.gettersToLocaleCurrency(this.input.row3.value);
      } else {
        return this.$store.getters[this.input.row3.value];
      }
    },
    row4value() {
      return this.gettersToLocaleCurrency(this.input.row4.value);
    },
    row5value() {
      return this.gettersToLocaleCurrency(this.input.row5.value);
    }
  }
};
</script>
